import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAppConfig } from '../../config/config';
import { prepareAuthHeaders } from '../../config/authConfig';
import { CombinationCalculationType, SpansAndLoads, LoadType } from '../../types/domainTypes';

export const calculationsApi = createApi({
  reducerPath: 'calculationsApi',
  baseQuery: fetchBaseQuery({ prepareHeaders: prepareAuthHeaders }),
  tagTypes: ['CalculationData'],
  endpoints: (builder) => ({
    fetchDesignScheme: builder.mutation<string, { spansAndLoads: SpansAndLoads; loadType: LoadType }>({
      query: ({ spansAndLoads, loadType }) => {
        return {
          url: `${getAppConfig().apiUrl}/calculations/designScheme/${loadType}`,
          method: 'POST',
          body: spansAndLoads,
          responseHandler: (response) => response.text(),
        };
      },
    }),
    getResultGraph: builder.query<string, { calculationId: string; type: CombinationCalculationType }>({
      query: ({ calculationId, type }) => {
        const url = `${getAppConfig().apiUrl}/calculations/${calculationId}/result/${type}`;
        return { url: url, method: 'GET', responseHandler: (response) => response.text() };
      },
      providesTags: ['CalculationData'],
    }),
    calculate: builder.mutation<string, { projectId: string; calculationId: string; includeFasteners: boolean }>({
      query: ({ projectId, calculationId, includeFasteners }) => {
        return {
          url: `${getAppConfig().apiUrl}/calculations/${projectId}/calculation/${calculationId}/generate?includeFasteners=${String(
            includeFasteners
          )}`,
          method: 'PUT',
          responseHandler: (response) => response.text(),
        };
      },
      invalidatesTags: ['CalculationData'],
    }),
  }),
});

export const { useFetchDesignSchemeMutation, useGetResultGraphQuery, useCalculateMutation, util } = calculationsApi;
